<era-pane>
  <h5 class="small-caps"
      i18n>App Analytics</h5>
  <form [formGroup]="appAnalyticsForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input rounded-3"
               role="switch"
               formControlName="appAnalyticsEnabled" />
        <label class="form-check-label"
               for="appAnalyticsEnabled">Turn App Analytics {{ (appAnalyticsEnabled.valueChanges | async) ? 'On' : 'Off'
          }}</label>
        <small class="text-muted">Sets the user preference of sharing analytics with app developers.</small>
      </div>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!appAnalyticsForm.valid">Submit</button>
  </form>
</era-pane>